<template>
  <div class="kanban_wrap ins002b">
    <div class="tb-list_ty1">
      <div class="tb-header clear">
        <div class="tb_num fl">
          <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: listTotalElements1 + listTotalElements2 + listTotalElements3 + listTotalElements4})"></div>
        </div> 
        <div class="tb_sort fr">
          <input type="checkbox" name="" id="checkReadfilterk" v-model="checkFilterRead" @change="checkReadfilter"><label for="checkReadfilterk">{{ $i18nUtil.trans("button.paper.unread", "미확인 보드 보기") }}</label> 
          <input type="checkbox" name="" id="filterBookmark" v-model="checkFilterBookmark" @change="filterBookmark" ><label for="filterBookmark">{{ $i18nUtil.trans("button.favorite", "즐겨찾기 보기") }}</label>
          <div class="dividing_line_ty1"></div>
          <CommonFilterB :folderList="folderList" :filterReset="filterReset" :filterId="'privateKanban'" :isPrivateBoard="true" @updateCommonFilterB="updateCommonFilterB" :initFilter="initFilter" />
        </div> 
      </div><!-- //tb-header -->
    </div><!-- //tb-list_ty1 -->

     <div class="kanban-cnt_ty1 clear col-4">
      <div class="kanban-col1 BEFORE">

        <div class="knanban-tit"><span class="ico-evaluate-good"></span>{{$i18nUtil.trans('entity.paper.paperStatus.GOOD','정상')}} ({{listTotalElements1 > 999 ? '999': listTotalElements1}})</div> 
        <div class="kanban-list-item no-data" v-if="listFilter1.length ==0">
          <div class="txt" v-if="list1.length == 0 && !( checkFilterRead || checkFilterBookmark)" v-html="$i18nUtil.trans('search.006', '보드가 없습니다.<br >Drag &#38; Drop으로<br> 등록된 보드를 이동할 수 있습니다.')">
          </div>
          <div class="txt" v-if="( checkFilterRead || checkFilterBookmark) && listFilter1.length == 0">
            {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
          </div>
        </div>
        <draggable id="BEFORE" data-source="BEFORE" v-model="listFilter1" :move="onMove" @add="addData" 
                   class="kanban-list-wrap" :class="listFilter1.length == 0 ? 'nodata':''" draggable=".item" group="a">
          <template v-for="(element,index ) in listFilter1">
            <div :id="'BEFORE'+index" class="kanban-list-item item"  :key="'BEFORE_'+index" v-if="index < listLength1">
              <div class="list-top clear">
                <div class="ico-evaluate-good fl"></div>
                <button type="button" class="ico-switch_favorites fr" 
                      :class="{active : element.paperBookmarkId != null }"  @click="toggleBookmark(element)">즐겨찾기</button>
              </div>
              <div class="folder_name ell-singleline"
                @mouseover="mouseEvt(true, element, $event, 'categoryName')"
                @mouseleave="mouseEvt(false, element, $event, 'categoryName')"
              >
                {{element.categoryInfo.categoryName}}
                <div class="tooltip-b tl small" :id="element.paperId+'_'+element.categoryInfo.categoryMid+'_tooltip'" style="white-space: normal;">
                  {{ element.categoryInfo.categoryName }}
                </div>
              </div>
              <div class="tit ell-multiline2 multi-ellipsis" :class="element.paperId+'_kanban'" @click="moveBoard(element)"
                @mouseover="mouseEvt(true, element, $event, 'paperTitle')"
                @mouseleave="mouseEvt(false, element, $event, 'paperTitle')"
              >
                {{ element.paperTitle }}
              </div>
              <div class="tooltip-b tl small paperTitle" :id="element.paperId+'_tooltip'">
                {{ element.paperTitle }}
              </div>
              <div class="list-bom">
                <div class="clear">
                  <div class="member fl">{{ defaultLanguage.indexOf('ko') != -1 ? element.regUserName : element.regUserNameEn != null ? element.regUserNameEn : element.regUserName }} 
                    <b> {{ element.paperUserCount > 999 ? '999+' : element.paperUserCount }}</b>
                  </div>
                  <div class="date fr">
                    <!-- 24시간 이내-->
                    <momentAgo v-if="checkHours(element.lastUpdDate)" prefix="" suffix="전" :date="element.lastUpdDate" lang="kr"></momentAgo>
                    <!-- 24시간 이후-->
                    {{ !checkHours(element.lastUpdDate) ? replaceAll(element.lastUpdDate.substring(0, 10), "-", ".") :''}} 
                    <span class="ico-new" v-if="element.readCount == null || element.readCount == 0"></span>
                  </div>
                </div>
                <div class="knanban-foot_wrap clear" v-if="element.commentCount != 0">
                  <div type="button" class="ico-txt_comment"> {{ element.commentCount > 999 ? '999+' : element.commentCount }} </div>
                </div>
              </div>
            </div>
          </template>
        </draggable>
        <div class="btn_box txtc">
          <button type="button" class="btn-more-ico_small1" v-if="listTotalElements1 > listLength1" @click="moreKanbanBoard(1)" >
            {{ $i18nUtil.trans("button.more.BoardKanban", "더보기") }}({{listTotalElements1 - listLength1 > 20 ? '20':listTotalElements1 - listLength1}})</button>
        </div>
      </div>

      <div class="kanban-col2 ongoing">
        <div class="knanban-tit"><span class="ico-evaluate-so"></span>{{$i18nUtil.trans('entity.paper.paperStatus.SO','이슈 발생')}} ({{listTotalElements2 > 999 ? '999': listTotalElements2}})</div>
        <div class="kanban-list-item no-data"  v-if="listFilter2.length ==0">
          <div class="txt" v-if="list2.length == 0 && !( checkFilterRead || checkFilterBookmark)" v-html="$i18nUtil.trans('search.006', '보드가 없습니다.<br >Drag &#38; Drop으로<br> 등록된 보드를 이동할 수 있습니다.')">
          </div>
          <div class="txt" v-if="( checkFilterRead || checkFilterBookmark) && listFilter2.length == 0">
            {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
          </div>
        </div>
        <draggable id="ONGOING" data-source="ONGOING" v-model="listFilter2" :move="onMove" @add="addData" 
                   class="kanban-list-wrap" :class="listFilter2.length == 0 ? 'nodata':''" draggable=".item" group="a">
          <template v-for="(element,index) in listFilter2">
            <div :id="'ONGOING'+index" class="kanban-list-item item"  :key="'ONGOING_'+index" v-if="index < listLength2">
              <div class="list-top clear">
                <div class="ico-evaluate-so fl"></div>
                <button type="button" class="ico-switch_favorites fr" 
                      :class="{active : element.paperBookmarkId != null }"  @click="toggleBookmark(element)">즐겨찾기
                </button>
              </div>
              <div class="folder_name ell-singleline"
                @mouseover="mouseEvt(true, element, $event, 'categoryName')"
                @mouseleave="mouseEvt(false, element, $event, 'categoryName')"
              > 
                {{element.categoryInfo.categoryName}}
                <div class="tooltip-b tl small" :id="element.paperId+'_'+element.categoryInfo.categoryMid+'_tooltip'" style="white-space: normal;">
                  {{ element.categoryInfo.categoryName }}
                </div>
              </div>
              <div class="tit ell-multiline2 multi-ellipsis" :class="element.paperId+'_kanban'" @click="moveBoard(element)"
                @mouseover="mouseEvt(true, element, $event, 'paperTitle')"
                @mouseleave="mouseEvt(false, element, $event, 'paperTitle')"
              >
                {{ element.paperTitle }}
              </div>
              <div class="tooltip-b tl small paperTitle" :id="element.paperId+'_tooltip'">
                {{ element.paperTitle }}
              </div>
              <div class="list-bom">
                <div class="clear">
                  <div class="member fl">{{ defaultLanguage.indexOf('ko') != -1 ? element.regUserName : element.regUserNameEn != null ? element.regUserNameEn : element.regUserName }} 
                    <b> {{ element.paperUserCount > 999 ? '999+' : element.paperUserCount }}</b>
                  </div>
                  <div class="date fr">
                      <!-- 24시간 이내-->
                    <momentAgo v-if="checkHours(element.lastUpdDate)" prefix="" suffix="전" :date="element.lastUpdDate" lang="kr"></momentAgo>
                    <!-- 24시간 이후-->
                    {{ !checkHours(element.lastUpdDate) ? replaceAll(element.lastUpdDate.substring(0, 10), "-", ".") :''}} 
                    <span class="ico-new" v-if="element.readCount == null || element.readCount == 0"></span>
                  </div>
                </div>
                <div class="knanban-foot_wrap clear" v-if="element.commentCount != 0">
                  <div type="button" class="ico-txt_comment">{{ element.commentCount > 999 ? '999+' : element.commentCount }} </div>
                </div>
              </div>
            </div>
          </template>
        </draggable>
        <div class="btn_box txtc">
          <button type="button" class="btn-more-ico_small1" v-if="listTotalElements2 > listLength2" @click="moreKanbanBoard(2)" >
            {{ $i18nUtil.trans("button.more.BoardKanban", "더보기") }}({{listTotalElements2 -listLength2 > 20 ? '20' :listTotalElements2 -listLength2}})</button>
        </div>
      </div>

      <div class="kanban-col3 suspend">
        <div class="knanban-tit"><span class="ico-evaluate-delay"></span>{{$i18nUtil.trans('entity.paper.paperStatus.DELAY','보고 필요')}} ({{listTotalElements3 > 999 ? '999': listTotalElements3}})</div>
        <div class="kanban-list-item no-data"  v-if="listFilter3.length ==0" >
          <div class="txt" v-if="list3.length == 0 && !( checkFilterRead || checkFilterBookmark)" v-html="$i18nUtil.trans('search.006', '보드가 없습니다.<br >Drag &#38; Drop으로<br> 등록된 보드를 이동할 수 있습니다.')">
          </div>
          <div class="txt" v-if="( checkFilterRead || checkFilterBookmark) && listFilter3.length == 0">
            {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
          </div>
        </div>
        <draggable id="SUSPEND" data-source="SUSPEND" v-model="listFilter3" :move="onMove" @add="addData"
                   class="kanban-list-wrap" :class="listFilter3.length == 0 ? 'nodata':''" draggable=".item" group="a">
          <template v-for="(element,index) in listFilter3">
            <div :id="'SUSPEND'+index" class="kanban-list-item item"  :key="'DELAY_'+index" v-if="index < listLength3">
              <div class="list-top clear">
                <div class="ico-evaluate-delay fl"></div>
                <button type="button" class="ico-switch_favorites fr" 
                      :class="{active : element.paperBookmarkId != null }"  @click="toggleBookmark(element)">즐겨찾기</button>
              </div>
              <div class="folder_name ell-singleline"
                @mouseover="mouseEvt(true, element, $event, 'categoryName')"
                @mouseleave="mouseEvt(false, element, $event, 'categoryName')"
              >
                {{element.categoryInfo.categoryName}}
                <div class="tooltip-b tl small" :id="element.paperId+'_'+element.categoryInfo.categoryMid+'_tooltip'" style="white-space: normal;">
                  {{ element.categoryInfo.categoryName }}
                </div>
              </div>
              <div class="tit ell-multiline2 multi-ellipsis" :class="element.paperId+'_kanban'" @click="moveBoard(element)"
                @mouseover="mouseEvt(true, element, $event, 'paperTitle')"
                @mouseleave="mouseEvt(false, element, $event, 'paperTitle')"
              >
                {{ element.paperTitle }}
              </div>
              <div class="tooltip-b tl small paperTitle" :id="element.paperId+'_tooltip'">
                {{ element.paperTitle }}
              </div>
              <div class="list-bom">
                <div class="clear">
                  <div class="member fl">{{ defaultLanguage.indexOf('ko') != -1 ? element.regUserName : element.regUserNameEn != null ? element.regUserNameEn : element.regUserName }} 
                    <b> {{ element.paperUserCount > 999 ? '999+' : element.paperUserCount }}</b>
                  </div>
                  <div class="date fr">
                      <!-- 24시간 이내-->
                    <momentAgo v-if="checkHours(element.lastUpdDate)" prefix="" suffix="전" :date="element.lastUpdDate" lang="kr"></momentAgo>
                    <!-- 24시간 이후-->
                    {{ !checkHours(element.lastUpdDate) ? replaceAll(element.lastUpdDate.substring(0, 10), "-", ".") :''}} 
                    <span class="ico-new" v-if="element.readCount == null || element.readCount == 0"></span>
                  </div>
                </div>
                <div class="knanban-foot_wrap clear" v-if="element.commentCount != 0">
                  <div type="button" class="ico-txt_comment"> {{ element.commentCount > 999 ? '999+' : element.commentCount }} </div>
                </div>
              </div>
            </div>
          </template>
        </draggable>
        <div class="btn_box txtc">
          <button type="button" class="btn-more-ico_small1" v-if="listTotalElements3 > listLength3" @click="moreKanbanBoard(3)">
            {{ $i18nUtil.trans("button.more.BoardKanban", "더보기") }}({{listTotalElements3 - listLength3 > 20 ? '20':listTotalElements3 - listLength3}})</button>
        </div>
      </div>

      <div class="kanban-col4 completion">
        <div class="knanban-tit"><span class="ico-evaluate-exceeded"></span>{{$i18nUtil.trans('entity.paper.paperStatus.EXCEEDED','종료')}} ({{listTotalElements4 > 999 ? '999': listTotalElements4}})</div>
        <div class="kanban-list-item no-data"  v-if="listFilter4.length ==0">
          <div class="txt" v-if="list4.length == 0 && !(checkFilterRead || checkFilterBookmark)" v-html="$i18nUtil.trans('search.006', '보드가 없습니다.<br >Drag &#38; Drop으로<br> 등록된 보드를 이동할 수 있습니다.')">
          </div>
          <div class="txt" v-if="(checkFilterRead || checkFilterBookmark) && listFilter4.length == 0">
            {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
          </div>
        </div>
        <draggable id="COMPLETION" data-source="COMPLETION" v-model="listFilter4" :move="onMove" @add="addData"
                   class="kanban-list-wrap" :class="listFilter4.length == 0 ? 'nodata':''" draggable=".item" group="a">
          <template  v-for="(element,index) in listFilter4" >
            <div :id="'COMPLETION'+index" class="kanban-list-item item" :key="'COMPLETION_'+index" v-if="index < listLength4">
              <div class="list-top clear">
                <div class="ico-evaluate-exceeded fl"></div>
                <button type="button" class="ico-switch_favorites fr" 
                      :class="{active : element.paperBookmarkId != null }"  @click="toggleBookmark(element)">즐겨찾기
                </button>
              </div>
              <div class="folder_name ell-singleline"
                @mouseover="mouseEvt(true, element, $event, 'categoryName')"
                @mouseleave="mouseEvt(false, element, $event, 'categoryName')"
              >
                {{element.categoryInfo.categoryName}} 
                <div class="tooltip-b tl small" :id="element.paperId+'_'+element.categoryInfo.categoryMid+'_tooltip'" style="white-space: normal;">
                  {{ element.categoryInfo.categoryName }}
                </div>
              </div>
              <div class="tit ell-multiline2 multi-ellipsis" :class="element.paperId+'_kanban'" @click="moveBoard(element)"
                @mouseover="mouseEvt(true, element, $event, 'paperTitle')"
                @mouseleave="mouseEvt(false, element, $event, 'paperTitle')"
              >
                {{ element.paperTitle }}
              </div>
              <div class="tooltip-b tl small paperTitle" :id="element.paperId+'_tooltip'">
                {{ element.paperTitle }}
              </div>
              <div class="list-bom">
                <div class="clear">
                  <div class="member fl">{{ defaultLanguage.indexOf('ko') != -1 ? element.regUserName : element.regUserNameEn != null ? element.regUserNameEn : element.regUserName }} 
                    <b> {{ element.paperUserCount > 999 ? '999+' : element.paperUserCount }}</b>
                  </div>
                  <div class="date fr">
                      <!-- 24시간 이내-->
                    <momentAgo v-if="checkHours(element.lastUpdDate)" prefix="" suffix="전" :date="element.lastUpdDate" lang="kr"></momentAgo>
                    <!-- 24시간 이후-->
                    {{ !checkHours(element.lastUpdDate) ? replaceAll(element.lastUpdDate.substring(0, 10), "-", ".") :''}} 
                    <span class="ico-new" v-if="element.readCount == null || element.readCount == 0"></span>
                  </div>
                </div>
                <div class="knanban-foot_wrap clear" v-if="element.commentCount != 0">
                  <div type="button" class="ico-txt_comment">{{ element.commentCount > 999 ? '999+' : element.commentCount }} </div>
                </div>
              </div>
            </div>
          </template>
        </draggable>
        <div class="btn_box txtc">
          <button type="button" class="btn-more-ico_small1" v-if="listTotalElements4 > listLength4" @click="moreKanbanBoard(4)">
            {{ $i18nUtil.trans("button.more.BoardKanban", "더보기") }}({{listTotalElements4 -listLength4 > 20 ? '20':listTotalElements4 -listLength4}})</button>
        </div>
      </div>
    </div><!-- //Kanban_wrap -->
</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import draggable from "vuedraggable";
import axios from "axios";
import CommonFilterB from "@/components/cowork/common/filter/CommonFilterB";
let id = 1;

export default {
  name: "two-list-headerslots",
  display: "Two list header slot",
  order: 14,
  components: {
    draggable,
    CommonFilterB,
  },
 /*  props: ["iList", "eList"], */
  data() {
    return {
      groupId:'',

      list1: [],
      list2: [],
      list3: [],
      list4: [],

      listFilter1: [],
      listFilter2: [],
      listFilter3: [],
      listFilter4: [],

      listLength1:20,
      listLength2:20,
      listLength3:20,
      listLength4:20,
      
      listTotalElements1:0,
      listTotalElements2:0,
      listTotalElements3:0,
      listTotalElements4:0,
      
      page1:0,
      page2:0,
      page3:0,
      page4:0,

      offset1:0,
      offset2:0,
      offset3:0,
      offset4:0,

      status: [],
      editable: true,
      isDragging: false,
      delayedDragging: false, 
  
      goodCount: 0, // 우수 G
      soCount: 0, //양호 Y
      delayCount: 0, // 지연 R


      draggedObj : null,
      relatedObj :null,
      targetState : null,
      state:null,  


      filterFolderName : "폴더 전체",
      filterUserName : "생성/수정자 전체",
      totalListChecked : true,

      iList:[],
      eList:[],

      //filter 수정 
      todayDate:this.$moment().format('YYYYMMDD'),
      
      foldersArr:[],
      folderSelectedArr:[],
      folderSelectedAll:true,

      regUserArr:[],
      regUserSelectedArr:[],
      regUserSelectedAll:true,

      statusSelectedArr:[],

      signalSelectedArr:[], 

      openSelectedArr:[],

      checkFilterRead:false,
      checkFilterBookmark:false,

      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

      /* 필터 */
      folderList: [],
      filterReset: false,
      categoryMidList: [],
      gradeCodeList: [],
      statusList: [],
      
      initFilter:[],

      categoryCheckYn : false,
      gradeCheckYn : false,
      statusCheckYn : false,

      defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    totalListChecked(){
      // console.log(this.totalListChecked);
      if(this.totalListChecked){ 
        this.listFilter1 = this.list1;
        this.listFilter2 = this.list2;
        this.listFilter3 = this.list3;
        this.listFilter4 = this.list4;
      }
    },
    getExecutionCategoryMid() {
      this.getList(this.groupId);
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    listFilter1() {
      this.listFilter1.forEach(item => {
        this.multiElipsis(2, item.paperId)
      })
    },
    listFilter2() {
      this.listFilter2.forEach(item => {
        this.multiElipsis(2, item.paperId)
      })
    },
    listFilter3() {
      this.listFilter3.forEach(item => {
        this.multiElipsis(2, item.paperId)
      })
    },listFilter4() {
      this.listFilter4.forEach(item => {
        this.multiElipsis(2, item.paperId)
      })
    },
  },
  methods: {
    ...mapActions("common", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]), 
    ...mapActions("modals", ["showToast"]), 

    /* 툴팁 */
    mouseEvt(flag, item, event, target) {
      let tooltipId;
      let paperTitleLoc;
      if(target === 'categoryName') {
        tooltipId = item.paperId+'_'+item.categoryMid+'_tooltip';
      }else if(target === 'linkedProject' ){
        tooltipId = item.paperId+'_'+item.linkProjectId+'_tooltip';
      }else{
        tooltipId = item.paperId+'_tooltip';
        // tooltipId = item.id+'_'+item.paperId+'_tooltip';
        // let style = event.target.getBoundingClientRect();
        // paperTitleLoc = Math.abs(style.left - style.right);
      }
      if(flag) {
        // 말줄임(...) css 적용 여부 체크 (boolean)
        let val;
        val = target !== 'paperTitle' ? this.$tooltip.hasOverflownWidth(event.target) : this.$tooltip.hasOverflownHeight(event.target)
        if(val) {
          document.getElementById(tooltipId).style.display = 'block';
        }else{
          document.getElementById(tooltipId).style.display = 'none';
        };
      }else{
        document.getElementById(tooltipId).style.display = 'none';
      }
    },

    initBoardKanban(groupId, state){ 
      this.list1 = [];
      this.list2 = [];
      this.list3 = [];
      this.list4 = [];
      this.listFilter1 = [];
      this.listFilter2 = [];
      this.listFilter3 = [];
      this.listFilter4 = [];
      this.listLength1 = 20,
      this.listLength2 = 20,
      this.listLength3 = 20,
      this.listLength4 = 20,

           
      this.listTotalElements1 = 0,
      this.listTotalElements2 = 0,
      this.listTotalElements3 = 0,
      this.listTotalElements4 = 0,
      
      this.page1 = 0,
      this.page2 = 0,
      this.page3 = 0,
      this.page4 = 0,

      this.checkFilterRead = false;
      this.checkFilterBookmark = false;

      this.groupId=groupId;
      if(window.sessionStorage.getItem("moveBoard") === 'true'){
        // 보드에서 돌아왔을 때 
        this.getList(groupId);
        this.getFolderList(groupId);
      }else{
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        if(stateArr.length == 0){
          //저장
          stateArr.push(state);
          window.sessionStorage.setItem("private",JSON.stringify(stateArr));
        }else{
          let lastState = stateArr[stateArr.length-1];  
          // let lastState = stateArr.pop();

          if(lastState.currentTab == 0 && lastState.currentTab2 == 1 && lastState.currentTab3 == 0){
            // 같은 탭 누른 경우 .
          }else{
            // 다른 탭에서 누른경우
            if(window.sessionStorage.getItem("prevBtn") === 'true'){
            }else{
              stateArr.push(state);
              window.sessionStorage.setItem("private",JSON.stringify(stateArr));
            } 
          }
        } 
        
        this.getList(groupId);
        this.getFolderList(groupId); 
      }

      // this.getList(groupId);
      // this.getFolderList(groupId);
    },
    getFolderList(groupId){
      let obj = this;
      let reqData = {};
      reqData.params ={
        groupId : groupId,
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/getGroupCategoryList";
      reqData.method = "post";
      
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
				.then( (res) =>{
					if(res.errorCode == null) {  
            let list = res.result[0].list;
            obj.folderList = list;
            obj.categoryMidList = [];
            obj.gradeCodeList = [];
            obj.statusCodeList = [];
            obj.filterReset = true;
            setTimeout(()=>{obj.filterReset = false;}, 50);
					}
				})
				.catch(function (err) {
					console.log(err);
				}); 
    },
    getList(groupId) {
      //  /api/copaper/paper/getPaperStatusPaperList
      //  paperStatus: this.status[0],
      //  groupId : groupId
      let myAllPaperList=[];
      let statusList = [];
      statusList.push('GOOD'); 
      statusList.push('SO'); 
      statusList.push('DELAY'); 
      statusList.push('EXCEEDED');

      this.listTotalElements1 = 0,
      this.listTotalElements2 = 0,
      this.listTotalElements3 = 0,
      this.listTotalElements4 = 0,
      
      this.page1 = 0,
      this.page2 = 0,
      this.page3 = 0,
      this.page4 = 0,

      this.openSelectedArr=[];
      this.openSelectedArr.push("MY");
      this.openSelectedArr.push("NORMAL");
      this.openSelectedArr.push("SECRET");

      this.signalSelectedArr=[];
      this.signalSelectedArr.push("R");
      this.signalSelectedArr.push("G");
      this.signalSelectedArr.push("Y"); 

      this.statusSelectedArr=[];
      this.statusSelectedArr.push('GOOD');
      this.statusSelectedArr.push('SO');
      this.statusSelectedArr.push('DELAY');
      this.statusSelectedArr.push('EXCEEDED');

      /* this.iFolderSelectedArr=[];
      this.eFolderSelectedArr=[]; */

      this.regUserArr =[];
      this.regUserSelectedArr=[];
      this.regUserSelectedAll=true;
      let regUsers = [];


      let obj = this;
      let list = statusList; 
      let axiosArr = []; 

      if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
        window.sessionStorage.setItem("moveBoard",false);
        window.sessionStorage.setItem("prevBtn",false);
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        let state = stateArr[stateArr.length-1];

        // 체크박스 설정 
        obj.checkFilterBookmark = state.isPaperBookmarkChecked;
        obj.checkFilterRead = state.isPaperReadChecked;

        //필터 유지.
        obj.categoryMidList = state.categoryMidList;
        obj.gradeCodeList = state.gradeCodeList;
        obj.statusList = state.statusList;

        obj.initFilter = {
          categoryMidList : state.categoryCheckYn ?  obj.categoryMidList : [],
          gradeCodeList : state.gradeCheckYn ? obj.gradeCodeList : [],
          statusList : state.statusCheckYn ? obj.statusList : []
        }
      }

      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let status = list[inx];    
          let url = "/api/copaper/paper/getPaperStatusPaperList"
          let data = {
            paperStatus: status,
            groupId : groupId,
            limitRow: "20",
            page: 0,
            isPaperBookmarkChecked: obj.checkFilterBookmark,
            isPaperReadChecked: obj.checkFilterRead,
            categoryMidList: obj.categoryMidList,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }
      }
      //프로그레스바 시작 
      this.showLoadingbar();
      if(axiosArr.length > 0) {
        axios.all(axiosArr).then(axios.spread((...responses) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if(responses.length > 0) { 
            this.list1 = responses[0].data.result.content;
            this.listFilter1 = responses[0].data.result.content;
            this.listTotalElements1 = responses[0].data.result.totalElements;
            this.list2 = responses[1].data.result.content;
            this.listFilter2 = responses[1].data.result.content;
            this.listTotalElements2 = responses[1].data.result.totalElements;
            this.list3 = responses[2].data.result.content;
            this.listFilter3 = responses[2].data.result.content;
            this.listTotalElements3 = responses[2].data.result.totalElements;
            this.list4 = responses[3].data.result.content;
            this.listFilter4 = responses[3].data.result.content;
            this.listTotalElements4 = responses[3].data.result.totalElements;


            responses.forEach((_res, indx) => {
              if(_res && _res.status == 200) {   
                let list = _res.data.result; 
                for (let k in list) {   
                  let userId = list[k].regUserId;
                  let userName =list[k].regUserName; 
                  if(regUsers.indexOf(userId) == -1){
                    let param = {
                      userId:userId,
                      userName : userName
                    }
                    regUsers.push(userId);
                    this.regUserArr.push(param);
                  } 
                } 
              } else {}
            });
          }
        })).catch(errors => { 
        });
      }  

      this.regUserArr.sort();
      this.regUserSelectedArr = regUsers;  
    },
    setSignal(data){
      if(data.length != 0 ){ 
        for (let k in data) {
          if (this.userIds.indexOf(data[k].regUserId) == -1) { 
            if (data[k].paperSignal == "Y") {
              this.soCount++;
            } else if (data[k].paperSignal == "G") {
              this.goodCount++;
            } else if (data[k].paperSignal == "R") {
              this.delayCount++;
            }
          }
        }
      }
    },
    changeState(paperState,targetState,changePaper){
      if(paperState == "BEFORE" ){
        this.list1.splice(changePaper.index,1);
        this.listTotalElements1 = this.listTotalElements1 - 1;
      }else if(paperState == "ONGOING"){
        this.list2.splice(changePaper.index,1);
        this.listTotalElements2 = this.listTotalElements2 - 1;
      }else if(paperState== "SUSPEND"){
        this.list3.splice(changePaper.index,1);
        this.listTotalElements3 = this.listTotalElements3 - 1;
      }else if(paperState == "COMPLETION"){
        this.list4.splice(changePaper.index,1);
        this.listTotalElements4 = this.listTotalElements4 - 1;
      }


      let goState = ""; 
      if(targetState== "BEFORE" ){
        this.list1.splice(changePaper.index,0);
        goState='GOOD';
        this.listTotalElements1 = this.listTotalElements1 +1;
      }else if(targetState == "ONGOING"){
        this.list2.splice(changePaper.index,0 ,changePaper.element);
        goState='SO';
        this.listTotalElements2 = this.listTotalElements2 +1;
      }else if(targetState == "SUSPEND"){
        this.list3.splice(changePaper.index,0, changePaper.element);
        goState='DELAY';
        this.listTotalElements3 = this.listTotalElements3 +1;
      }else if(targetState == "COMPLETION"){
        this.list4.splice(changePaper.index,0, changePaper.element);
        goState='EXCEEDED';
        this.listTotalElements4 = this.listTotalElements4 +1;
      }
      let param = {
        paperId : changePaper.element.paperId,
        paperStatus : goState
      }
       this.$axios
        .post("/api/copaper/paper/updatePaperStatus", param)
        .then((res) => {
          
        })
        .catch((error) => console.log(error)); 
    },
    addData(evt) { // 다른 쪽으로 drag&drop 을 해야 add가 되면서 실행 
     /*  console.log("addData");
      console.log(evt.from);
      console.log(evt.from.attributes[0].value);
      console.log(evt.to);
      console.log(evt.to.attributes[0].value); */
      this.paperStatus = evt.from.attributes[1].value;
      this.targetState = evt.to.attributes[1].value;

      // console.log(this.paperStatus + " => " +this.targetState);

      this.changeState(this.paperStatus,this.targetState,this.draggedObj);
    },
    onMove({ relatedContext, draggedContext }) {
      /* console.log("onMove"); */
      const relatedElement = relatedContext.element; // 같은 열에서 움직일때 변화되는 data (클릭해서 움직이는 데이터 X 밀리는데이터 O)
      const draggedElement = draggedContext.element; // 클릭해서 움직이는 data
      
      this.draggedObj = draggedContext;
      //BEFOR:시작전,ING:진행중,PAUSE:일시정지,COMPL:완료
      //BEFORE  ongoing   suspend   completion
     
    },
    // moveBoard(element) {
    //   let path = "/general/board/" + element.paperId;
    //   this.$router.push(path);
	// },
	moveBoard(board) {
    window.sessionStorage.setItem("moveBoard",true); 
	  let postPath = board.paperProjectLinkId == null ? (board.paperId) :  (board.paperId+"/"+board.paperProjectLinkId); 
	  let path = "/general/board/" + postPath; 
	  this.$router.push(path);
	},
    changeFilter() {
      if ( this.registUser == "all" &&  this.folderFilter == "all" && this.stateFilter == "all" ) {
        this.listFilter1 = this.list1;
        this.listFilter2 = this.list2;
        this.listFilter3 = this.list3;
        this.listFilter4 = this.list4;
      } else if (  this.registUser == "all" && this.folderFilter == "all" && this.stateFilter != "all" ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return board.paperSignal == obj.stateFilter;
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return board.paperSignal == obj.stateFilter;
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return board.paperSignal == obj.stateFilter;
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return board.paperSignal == obj.stateFilter;
        });
        this.listFilter4 = result4;
      } else if ( this.registUser == "all" && this.folderFilter != "all" && this.stateFilter == "all"  ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return board.categoryMid == obj.folderFilter;
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return board.categoryMid == obj.folderFilter;
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return board.categoryMid == obj.folderFilter;
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return board.categoryMid == obj.folderFilter;
        });
        this.listFilter4 = result4;
      } else if ( this.registUser == "all" && this.folderFilter != "all" && this.stateFilter != "all"  ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return (
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return (
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return (
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return (
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter4 = result4;
      } else if ( this.registUser != "all" && this.folderFilter == "all" && this.stateFilter == "all" ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return board.regUserId == obj.registUser;
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return board.regUserId == obj.registUser;
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return board.regUserId == obj.registUser;
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return board.regUserId == obj.registUser;
        });
        this.listFilter4 = result4;
      } else if ( this.registUser != "all" &&  this.folderFilter == "all" && this.stateFilter != "all" ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter4 = result4;
      } else if ( this.registUser != "all" && this.folderFilter != "all" && this.stateFilter == "all"  ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter
          );
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter
          );
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter
          );
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter
          );
        });
        this.listFilter4 = result4;
      } else if ( this.registUser != "all" && this.folderFilter != "all" && this.stateFilter != "all" ) {
        let obj = this;
        const result1 = this.list1.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter1 = result1;
        const result2 = this.list2.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter2 = result2;
        const result3 = this.list3.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter3 = result3;
        const result4 = this.list4.filter(function (board) {
          return (
            board.regUserId == obj.registUser &&
            board.categoryMid == obj.folderFilter &&
            board.paperSignal == obj.stateFilter
          );
        });
        this.listFilter4 = result4;
      }
    },
    filterBookmark(event) {
      this.getKanbanAllBoardList();
      // event.target.classList.toggle("active");
      // this.folderFilter = "all";
      // this.stateFilter = "all";
      // this.registUser = "all";
      // this.filterFolderName="폴더 전체";
      // this.filterUserName="생성/수정자 전체";

      // this.setFilter();
      // if (event.target.classList.length == 1) {
      //   let obj = this;
      //   const result1 = this.list1.filter(function (board) {
      //     return board.paperBookmarkId != null;
      //   });
      //   this.listFilter1 = result1;

      //   const result2 = this.list2.filter(function (board) {
      //     return board.paperBookmarkId != null;
      //   });
      //   this.listFilter2 = result2;

      //   const result3 = this.list3.filter(function (board) {
      //     return board.paperBookmarkId != null;
      //   });
      //   this.listFilter3 = result3;

      //   const result4 = this.list4.filter(function (board) {
      //     return board.paperBookmarkId != null;
      //   });
      //   this.listFilter4 = result4;
      // } else {
      //   this.listFilter1 = this.list1;
      //   this.listFilter2 = this.list2;
      //   this.listFilter3 = this.list3;
      //   this.listFilter4 = this.list4;
      // }
    },
    toggleBookmark(board){
      event.target.classList.toggle('active');
      let statusCheck = event.target.parentNode.parentNode.parentNode.parentNode.classList[1];
      // console.log(statusCheck);

      let obj = this;
      let reqData = {};
      reqData.params ={
        paperId: board.paperId,
        bookmarkId:board.paperBookmarkId
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/bookmark/savePaperBookmark";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          if(statusCheck == 'BEFORE'){
            for(let k in this.list1){
              if(this.list1[k].paperId == board.paperId){
                this.list1[k].paperBookmarkId = res.result;
              }
            }
          }else if(statusCheck == 'ongoing'){
            for(let k in this.list2){
              if(this.list2[k].paperId == board.paperId){
                this.list2[k].paperBookmarkId = res.result;
              }
            }
          }else if(statusCheck == 'suspend'){
            for(let k in this.list3){
              if(this.list3[k].paperId == board.paperId){
                this.list3[k].paperBookmarkId = res.result;
              }
            }
          }else if(statusCheck == 'completion'){
            for(let k in this.list4){
              if(this.list4[k].paperId == board.paperId){
                this.list4[k].paperBookmarkId = res.result;
              }
            }
          }
          if(res.result != null) {
            obj.toastInfo.message = obj.$i18nUtil.trans('TB041', '즐겨찾기가 설정되었습니다.');
            obj.showToast(obj.toastInfo);
          } 
          else {
            obj.toastInfo.message = obj.$i18nUtil.trans('TB042', '즐겨찾기가 해제되었습니다.');
            obj.showToast(obj.toastInfo);
          }
          obj.getKanbanAllBoardList();
        }) 
        .catch(function(err) {
          console.log(err);
        }); 
    },
    /* 필터 수정  */
    folderSelected(){
      let filter = event.target.value; 
      this.folderSelectedAll =false;

      if(this.folderSelectedArr.indexOf(filter) == -1){
        this.folderSelectedArr.push(filter);
      }else{
        this.folderSelectedArr.splice(this.folderSelectedArr.indexOf(filter),1);
      }
       
      if(this.folderSelectedArr.length == this.foldersArr.length){
        this.folderSelectedAll =true;
      } 

      // this.setFilter();
    },
    evFolderSelectedAll(){
      
      if(this.folderSelectedAll){
        this.folderSelectedArr = [];
        
      }else{
        // console.log(this.foldersArr);  
        this.folderSelectedArr = []; 
        for(let k in this.foldersArr){
          let categoryMid=this.foldersArr[k].categoryMid;
          if(this.folderSelectedArr.indexOf(categoryMid) == -1){
            this.folderSelectedArr.push(categoryMid);  
          } 
        } 
      }
 
      // this.setFilter();
    },
    openSelected(data){
      // console.log(data);
      event.target.parentElement.classList.toggle("active"); 
          
      if(this.openSelectedArr.indexOf(data) == -1){
        this.openSelectedArr.push(data);
      }else{
        this.openSelectedArr.splice(this.openSelectedArr.indexOf(data),1);
      }
      // this.setFilter();
    },
    signalSelected(data){
      event.target.parentElement.classList.toggle("active"); 

      if(this.signalSelectedArr.indexOf(data) == -1){
        this.signalSelectedArr.push(data);
      }else{
        event.target.parentElement.parentElement.childNodes[0].classList.remove("active");
        this.signalSelectedArr.splice(this.signalSelectedArr.indexOf(data),1);
      }

      if(this.signalSelectedArr.length == 3){
        event.target.parentElement.parentElement.childNodes[0].classList.add("active"); 
      }

      // this.setFilter();
    },
    signalSelectedAll(){
      if(this.signalSelectedArr.length == 3){
        let tag = event.target.parentElement.parentElement.childNodes;
        for(let k in tag){
          if(tag[k].nodeName == "LI"){
            tag[k].classList.remove("active");
          }
        }
        this.signalSelectedArr = [];
      }else{
        let tag = event.target.parentElement.parentElement.childNodes;
        for(let k in tag){
          if(tag[k].nodeName == "LI"){
            tag[k].classList.add("active");
          }
        }   
        this.signalSelectedArr=[];
        this.signalSelectedArr.push("R");
        this.signalSelectedArr.push("G");
        this.signalSelectedArr.push("Y"); 
      }
 

      // this.setFilter();
    },
    fStatusSelectedArr(data){ 
      event.target.parentElement.classList.toggle("active"); 

      if(this.statusSelectedArr.indexOf(data) == -1){
        this.statusSelectedArr.push(data);
      }else{
        event.target.parentElement.parentElement.childNodes[0].classList.remove("active");
        this.statusSelectedArr.splice(this.statusSelectedArr.indexOf(data),1);
      }

      if(this.statusSelectedArr.length == 4){
        event.target.parentElement.parentElement.childNodes[0].classList.add("active"); 
      }

      // this.setFilter();
    },
    statusSelectedAll(){ 

      if(this.statusSelectedArr.length == 4){
        let tag = event.target.parentElement.parentElement.childNodes;
        for(let k in tag){
          if(tag[k].nodeName == "LI"){
            tag[k].classList.remove("active");
          }
        }
        this.statusSelectedArr = [];
      }else{
        let tag = event.target.parentElement.parentElement.childNodes;
        for(let k in tag){
          if(tag[k].nodeName == "LI"){
            tag[k].classList.add("active");
          }
        }
        this.statusSelectedArr=[];
        this.statusSelectedArr.push('GOOD');
        this.statusSelectedArr.push('SO');
        this.statusSelectedArr.push('DELAY');
        this.statusSelectedArr.push('EXCEEDED');
      }

      // this.setFilter();
    },
    selectedRegUser(){
      let filter = event.target.value;

      if(this.regUserSelectedArr.indexOf(filter) == -1){ 
        this.regUserSelectedArr.push(filter);
      }else{ 
        this.regUserSelectedAll=false;
        this.regUserSelectedArr.splice(this.regUserSelectedArr.indexOf(filter),1);
      }

      if(this.regUserSelectedArr.length == this.regUserArr.length){
        this.regUserSelectedAll = true; 
      }

      // this.setFilter();
    },
    selectedRegUserAll(){  
      if(this.regUserSelectedAll){
        this.regUserSelectedArr=[];
      }else{
        this.regUserSelectedArr=[];
        for(let k in this.regUserArr){
          this.regUserSelectedArr.push(this.regUserArr[k].userId);
        } 
      }
      // this.setFilter();
    },
    setFilter(item){
      this.listFilter1 = this.list1;
      this.listFilter2 = this.list2;
      this.listFilter3 = this.list3;
      this.listFilter4 = this.list4; 

      if (this.checkFilterBookmark) {
        let obj = this;
        const result1 = this.listFilter1.filter(function (board) {
          return board.paperBookmarkId != null;
        });
        this.listFilter1 = result1;

        const result2 = this.listFilter2.filter(function (board) {
          return board.paperBookmarkId != null;
        });
        this.listFilter2 = result2;

        const result3 = this.listFilter3.filter(function (board) {
          return board.paperBookmarkId != null;
        });
        this.listFilter3 = result3;

        const result4 = this.listFilter4.filter(function (board) {
          return board.paperBookmarkId != null;
        });
        this.listFilter4 = result4;
      } 
       
      if(this.checkFilterRead){
        this.listFilter1 = this.listFilter1.filter(function(data){
            return data.readCount == null || data.readCount == 0
        });
        this.listFilter2 = this.listFilter2.filter(function(data){
            return data.readCount == null || data.readCount == 0
        });
        this.listFilter3 = this.listFilter3.filter(function(data){
            return data.readCount == null || data.readCount == 0
        });
        this.listFilter4 = this.listFilter4.filter(function(data){
            return data.readCount == null || data.readCount == 0
        });
      } 

      /* 폴더 */
      //this.setFolderFilter(); 
      /* 공개 */
      //this.setOpenFilter(); 
      /* 평가상태  */
      // this.setSignalFilter(); 
      /* 진행상태 */
      //this.setStatusFilter(); 
      /* 작성자 */
      //this.setRegUserFilter(); 
    },
    setFolderFilter(){ 
      let jsonString1="[";
      let jsonString2="[";
      let jsonString3="[";
      let jsonString4="[";
      for(let k in this.folderSelectedArr){
        let filter = this.folderSelectedArr[k]; 
        let result1=[];
        let result2=[];
        let result3=[];
        let result4=[]; 
        
        result1 = this.listFilter1.filter(function(board){ 
          return board.categoryMid == filter;  
        });
        result2 = this.listFilter2.filter(function(board){ 
          return board.categoryMid == filter;
        }); 
        result3 = this.listFilter3.filter(function(board){ 
          return board.categoryMid == filter;
        });
        result4 = this.listFilter4.filter(function(board){ 
          return board.categoryMid == filter;
        });
           
        if(result1.length != 0){
          let jsonResultString1 = JSON.stringify(result1);
          jsonString1 += jsonResultString1.substring(1,jsonResultString1.length-1) +','; 
        }
        if(result2.length != 0){
          let jsonResultString2 = JSON.stringify(result2);
          jsonString2 += jsonResultString2.substring(1,jsonResultString2.length-1) +','; 
        }
        if(result3.length != 0){
          let jsonResultString3 = JSON.stringify(result3);
          jsonString3 += jsonResultString3.substring(1,jsonResultString3.length-1) +','; 
        }
        if(result4.length != 0){
          let jsonResultString4 = JSON.stringify(result4);
          jsonString4 += jsonResultString4.substring(1,jsonResultString4.length-1) +','; 
        }
      } 

      if(jsonString1.length != 1){
        jsonString1 = jsonString1.slice(0,-1)+"]";
      }else{
        jsonString1="[]";
      }
      this.listFilter1 = JSON.parse(jsonString1);

      if(jsonString2.length != 1){
        jsonString2 = jsonString2.slice(0,-1)+"]";
      }else{
        jsonString2="[]";
      }
      this.listFilter2 = JSON.parse(jsonString2);

      if(jsonString3.length != 1){
        jsonString3 = jsonString3.slice(0,-1)+"]";
      }else{
        jsonString3="[]";
      }
      this.listFilter3 = JSON.parse(jsonString3);

      if(jsonString4.length != 1){
        jsonString4 = jsonString4.slice(0,-1)+"]";
      }else{
        jsonString4="[]";
      }
      this.listFilter4 = JSON.parse(jsonString4);
    }, 
    setOpenFilter(){
      /* 공개  */
      let jsonString1="[";
      let jsonString2="[";
      let jsonString3="[";
      let jsonString4="[";
      for(let k in this.openSelectedArr){
        let filter = this.openSelectedArr[k]; 
        let result1=[];
        let result2=[];
        let result3=[];
        let result4=[];
        if(filter == "MY"){ 
          result1 = this.listFilter1.filter(function(board){
              return board.regUserId == localStorage.getItem("userId");
          });
          result2 = this.listFilter2.filter(function(board){ 
              return board.regUserId == localStorage.getItem("userId");
          });
          result3 = this.listFilter3.filter(function(board){
              return board.regUserId == localStorage.getItem("userId");
          });
          result4 = this.listFilter4.filter(function(board){
              return board.regUserId == localStorage.getItem("userId");
          });
        }else{
          if(this.openSelectedArr.indexOf("MY") == -1){
            result1 = this.listFilter1.filter(function(board){ 
                return board.docGrade == filter;
            });
            result2 = this.listFilter2.filter(function(board){ 
                return board.docGrade == filter;
            }); 
            result3 = this.listFilter3.filter(function(board){ 
                return board.docGrade == filter;
            }); 
            result4 = this.listFilter4.filter(function(board){ 
                return board.docGrade == filter;
            });  
          }else{
            result1 = this.listFilter1.filter(function(board){ 
                return board.docGrade == filter && board.regUserId != localStorage.getItem("userId");
            });
            result2 = this.listFilter2.filter(function(board){ 
                return board.docGrade == filter && board.regUserId != localStorage.getItem("userId");
            });
            result3 = this.listFilter3.filter(function(board){ 
                return board.docGrade == filter && board.regUserId != localStorage.getItem("userId");
            });
            result4 = this.listFilter4.filter(function(board){ 
                return board.docGrade == filter && board.regUserId != localStorage.getItem("userId");
            }); 
          }
        }

        if(result1.length != 0){
          let jsonResultString1 = JSON.stringify(result1);
          jsonString1 += jsonResultString1.substring(1,jsonResultString1.length-1) +','; 
        }
        if(result2.length != 0){
          let jsonResultString2 = JSON.stringify(result2);
          jsonString2 += jsonResultString2.substring(1,jsonResultString2.length-1) +','; 
        }
        if(result3.length != 0){
          let jsonResultString3 = JSON.stringify(result3);
          jsonString3 += jsonResultString3.substring(1,jsonResultString3.length-1) +','; 
        }
        if(result4.length != 0){
          let jsonResultString4 = JSON.stringify(result4);
          jsonString4 += jsonResultString4.substring(1,jsonResultString4.length-1) +','; 
        }
      } 

      if(jsonString1.length != 1){
        jsonString1 = jsonString1.slice(0,-1)+"]";
      }else{
        jsonString1="[]";
      }
      this.listFilter1 = JSON.parse(jsonString1);
      if(jsonString2.length != 1){
        jsonString2 = jsonString2.slice(0,-1)+"]";
      }else{
        jsonString2="[]";
      }
      this.listFilter2 = JSON.parse(jsonString2);
      if(jsonString3.length != 1){
        jsonString3 = jsonString3.slice(0,-1)+"]";
      }else{
        jsonString3="[]";
      }
      this.listFilter3 = JSON.parse(jsonString3);
      if(jsonString4.length != 1){
        jsonString4 = jsonString4.slice(0,-1)+"]";
      }else{
        jsonString4="[]";
      }
      this.listFilter4 = JSON.parse(jsonString4);
    },
    setSignalFilter(){
      let todayDate = this.todayDate;
      let jsonString1="[";
      let jsonString2="[";
      let jsonString3="[";
      let jsonString4="[";
      for(let k in this.signalSelectedArr){
        let filter = this.signalSelectedArr[k]; 
        let result1=[];
        let result2=[];
        let result3=[];
        let result4=[]; 
        
        result1 = this.listFilter1.filter(function(board){
          return board.paperSignal == filter;  
        });
        result2 = this.listFilter2.filter(function(board){
          return board.paperSignal == filter;
        });
        result3 = this.listFilter3.filter(function(board){
          return board.paperSignal == filter;
        });
        result4 = this.listFilter4.filter(function(board){
          return board.paperSignal == filter;
        });
           
        if(result1.length != 0){
          let jsonResultString1 = JSON.stringify(result1);
          jsonString1 += jsonResultString1.substring(1,jsonResultString1.length-1) +','; 
        }
        if(result2.length != 0){
          let jsonResultString2 = JSON.stringify(result2);
          jsonString2 += jsonResultString2.substring(1,jsonResultString2.length-1) +','; 
        }
        if(result3.length != 0){
          let jsonResultString3 = JSON.stringify(result3);
          jsonString3 += jsonResultString3.substring(1,jsonResultString3.length-1) +','; 
        }
        if(result4.length != 0){
          let jsonResultString4 = JSON.stringify(result4);
          jsonString4 += jsonResultString4.substring(1,jsonResultString4.length-1) +','; 
        }
      } 

      if(jsonString1.length != 1){
        jsonString1 = jsonString1.slice(0,-1)+"]";
      }else{
        jsonString1="[]";
      }
      this.listFilter1 = JSON.parse(jsonString1);
      if(jsonString2.length != 1){
        jsonString2 = jsonString2.slice(0,-1)+"]";
      }else{
        jsonString2="[]";
      }
      this.listFilter2 = JSON.parse(jsonString2);
      if(jsonString3.length != 1){
        jsonString3 = jsonString3.slice(0,-1)+"]";
      }else{
        jsonString3="[]";
      }
      this.listFilter3 = JSON.parse(jsonString3);
      if(jsonString4.length != 1){
        jsonString4 = jsonString4.slice(0,-1)+"]";
      }else{
        jsonString4="[]";
      }
      this.listFilter4 = JSON.parse(jsonString4);
    },
    setStatusFilter(){
      let jsonString1="[";
      let jsonString2="[";
      let jsonString3="[";
      let jsonString4="[";
      for(let k in this.statusSelectedArr){
        let filter = this.statusSelectedArr[k]; 
        let result1=[];
        let result2=[];
        let result3=[];
        let result4=[]; 
        
        result1 = this.listFilter1.filter(function(board){
          return board.paperStatus == filter;  
        });
        result2 = this.listFilter2.filter(function(board){
          return board.paperStatus == filter;
        });
        result3 = this.listFilter3.filter(function(board){
          return board.paperStatus == filter;
        });
        result4 = this.listFilter4.filter(function(board){
          return board.paperStatus == filter;
        });
           
        if(result1.length != 0){
          let jsonResultString1 = JSON.stringify(result1);
          jsonString1 += jsonResultString1.substring(1,jsonResultString1.length-1) +','; 
        }
        if(result2.length != 0){
          let jsonResultString2 = JSON.stringify(result2);
          jsonString2 += jsonResultString2.substring(1,jsonResultString2.length-1) +','; 
        }
        if(result3.length != 0){
          let jsonResultString3 = JSON.stringify(result3);
          jsonString3 += jsonResultString3.substring(1,jsonResultString3.length-1) +','; 
        }
        if(result4.length != 0){
          let jsonResultString4 = JSON.stringify(result4);
          jsonString4 += jsonResultString4.substring(1,jsonResultString4.length-1) +','; 
        }
      } 

      if(jsonString1.length != 1){
        jsonString1 = jsonString1.slice(0,-1)+"]";
      }else{
        jsonString1="[]";
      }
      this.listFilter1 = JSON.parse(jsonString1);
      if(jsonString2.length != 1){
        jsonString2 = jsonString2.slice(0,-1)+"]";
      }else{
        jsonString2="[]";
      }
      this.listFilter2 = JSON.parse(jsonString2);
      if(jsonString3.length != 1){
        jsonString3 = jsonString3.slice(0,-1)+"]";
      }else{
        jsonString3="[]";
      }
      this.listFilter3 = JSON.parse(jsonString3);
      if(jsonString4.length != 1){
        jsonString4 = jsonString4.slice(0,-1)+"]";
      }else{
        jsonString4="[]";
      }
      this.listFilter4 = JSON.parse(jsonString4);
    },
    setRegUserFilter(){
      let jsonString1="[";
      let jsonString2="[";
      let jsonString3="[";
      let jsonString4="[";
      for(let k in this.regUserSelectedArr){
        let filter = this.regUserSelectedArr[k]; 
        let result1=[];
        let result2=[];
        let result3=[];
        let result4=[]; 
        
        result1 = this.listFilter1.filter(function(board){
          return board.regUserId == filter;  
        });
        result2 = this.listFilter2.filter(function(board){
          return board.regUserId == filter;
        });
        result3 = this.listFilter3.filter(function(board){
          return board.regUserId == filter;
        });
        result4 = this.listFilter4.filter(function(board){
          return board.regUserId == filter;
        });
           
        if(result1.length != 0){
          let jsonResultString1 = JSON.stringify(result1);
          jsonString1 += jsonResultString1.substring(1,jsonResultString1.length-1) +','; 
        }
        if(result2.length != 0){
          let jsonResultString2 = JSON.stringify(result2);
          jsonString2 += jsonResultString2.substring(1,jsonResultString2.length-1) +','; 
        }
        if(result3.length != 0){
          let jsonResultString3 = JSON.stringify(result3);
          jsonString3 += jsonResultString3.substring(1,jsonResultString3.length-1) +','; 
        }
        if(result4.length != 0){
          let jsonResultString4 = JSON.stringify(result4);
          jsonString4 += jsonResultString4.substring(1,jsonResultString4.length-1) +','; 
        }
      } 

      if(jsonString1.length != 1){
        jsonString1 = jsonString1.slice(0,-1)+"]";
      }else{
        jsonString1="[]";
      }
      this.listFilter1 = JSON.parse(jsonString1);
      if(jsonString2.length != 1){
        jsonString2 = jsonString2.slice(0,-1)+"]";
      }else{
        jsonString2="[]";
      }
      this.listFilter2 = JSON.parse(jsonString2);
      if(jsonString3.length != 1){
        jsonString3 = jsonString3.slice(0,-1)+"]";
      }else{
        jsonString3="[]";
      }
      this.listFilter3 = JSON.parse(jsonString3);
      if(jsonString4.length != 1){
        jsonString4 = jsonString4.slice(0,-1)+"]";
      }else{
        jsonString4="[]";
      }
      this.listFilter4 = JSON.parse(jsonString4);
    },
    // moreKanbanBoard(moreKanbanBoard){
    //   //BEFORE ONGOING SUSPEND COMPLETION  
    //   if(moreKanbanBoard == 1){
    //     this.listLength1 += 20; 
    //     var objDiv = document.getElementById("BEFORE0");  
    //     let top = document.getElementById("BEFORE"); 
    //     top.scrollTop = (objDiv.scrollHeight*(this.listLength1-20)) +objDiv.scrollHeight; 

    //   }else if(moreKanbanBoard == 2){
    //     this.listLength2 += 20;   
    //     var objDiv = document.getElementById("ONGOING0");  
    //     let top = document.getElementById("ONGOING"); 
    //     top.scrollTop = (objDiv.scrollHeight*(this.listLength2-20)) +objDiv.scrollHeight; 
    //   }else if(moreKanbanBoard == 3){
    //     this.listLength3 += 20;  
    //     var objDiv = document.getElementById("SUSPEND0");  
    //     let top = document.getElementById("SUSPEND"); 
    //     top.scrollTop = (objDiv.scrollHeight*(this.listLength3-20)) +objDiv.scrollHeight; 
    //   }else if(moreKanbanBoard == 4){
    //     this.listLength4 += 20;  
    //     var objDiv = document.getElementById("COMPLETION0");  
    //     let top = document.getElementById("COMPLETION"); 
    //     top.scrollTop = (objDiv.scrollHeight*(this.listLength4-20)) +objDiv.scrollHeight; 
    //   } 
    // },
    moreKanbanBoard(kanbanNumber){ 
      let obj = this;
      let groupId = this.groupId;
      let statusList = [];
      statusList.push('GOOD'); 
      statusList.push('SO'); 
      statusList.push('DELAY'); 
      statusList.push('EXCEEDED');
      //BEFORE ONGOING SUSPEND COMPLETION  
      if(kanbanNumber == 1){
        obj.page1 = obj.page1 + 1;
        let status = statusList[0];    
        let param = {
          url: '/api/copaper/paper/getPaperStatusPaperList',
          method: 'post',
          req: {
            paperStatus: status,
            groupId: groupId,
            limitRow: "20",
            page: obj.page1,
            isPaperBookmarkChecked: obj.checkFilterBookmark,
            isPaperReadChecked: obj.checkFilterRead,
            categoryMidList: obj.categoryMidList,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
        };
        obj.COWORK_REST_ACTION(param)
          .then(function (res) {
            if(res.errorCode == null) {
              obj.list1 = res.result.content;
              obj.listFilter1 = obj.listFilter1.concat(res.result.content);
              obj.listTotalElements1 = res.result.totalElements;
             
              obj.listLength1 += 20; 
              var objDiv = document.getElementById("BEFORE0");  
              let top = document.getElementById("BEFORE"); 
              top.scrollTop = (objDiv.scrollHeight*(obj.listLength1-20)) +objDiv.scrollHeight; 
            }
          })
        .catch(function (err) {
          console.log(err);
        });
      }else if(kanbanNumber == 2){
        obj.page2 = obj.page2 + 1;
        let status = statusList[1];    
        let param = {
          url: '/api/copaper/paper/getPaperStatusPaperList',
          method: 'post',
          req: {
            paperStatus: status,
            groupId: groupId,
            limitRow: "20",
            page: obj.page2,
            isPaperBookmarkChecked: obj.checkFilterBookmark,
            isPaperReadChecked: obj.checkFilterRead,
            categoryMidList: obj.categoryMidList,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
        };
        obj.COWORK_REST_ACTION(param)
          .then(function (res) {
            if(res.errorCode == null) {
              obj.list2 = res.result.content;
              obj.listFilter2 = obj.listFilter2.concat(res.result.content);
              obj.listTotalElements2 = res.result.totalElements;
             
              obj.listLength2 += 20;  
              var objDiv = document.getElementById("ONGOING0");  
              let top = document.getElementById("ONGOING"); 
              top.scrollTop = (objDiv.scrollHeight*(obj.listLength2-20)) +objDiv.scrollHeight; 
            }
          })
        .catch(function (err) {
          console.log(err);
        });
        
      }else if(kanbanNumber == 3){
        obj.page3 = obj.page3 + 1;
        let status = statusList[2];    
        let param = {
          url: '/api/copaper/paper/getPaperStatusPaperList',
          method: 'post',
          req: {
            paperStatus: status,
            groupId: groupId,
            limitRow: "20",
            page: obj.page3,
            isPaperBookmarkChecked: obj.checkFilterBookmark,
            isPaperReadChecked: obj.checkFilterRead,
            categoryMidList: obj.categoryMidList,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
        };
        obj.COWORK_REST_ACTION(param)
          .then(function (res) {
            if(res.errorCode == null) {
              obj.list3 = res.result.content;
              obj.listFilter3 = obj.listFilter3.concat(res.result.content);
              obj.listTotalElements3 = res.result.totalElements;
             
              obj.listLength3 += 20;  
              var objDiv = document.getElementById("SUSPEND0");  
              let top = document.getElementById("SUSPEND"); 
              top.scrollTop = (objDiv.scrollHeight*(obj.listLength3-20)) +objDiv.scrollHeight; 
            }
          })
        .catch(function (err) {
          console.log(err);
        });
        
      }else if(kanbanNumber == 4){
        obj.page4 = obj.page4 + 1;
        let status = statusList[3];    
        let param = {
          url: '/api/copaper/paper/getPaperStatusPaperList',
          method: 'post',
          req: {
            paperStatus: status,
            groupId: groupId,
            limitRow: "20",
            page: obj.page4,
            isPaperBookmarkChecked: obj.checkFilterBookmark,
            isPaperReadChecked: obj.checkFilterRead,
            categoryMidList: obj.categoryMidList,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
        };
        obj.COWORK_REST_ACTION(param)
          .then(function (res) {
            if(res.errorCode == null) {
              obj.list4 = res.result.content;
              obj.listFilter4 = obj.listFilter4.concat(res.result.content);
              obj.listTotalElements4 = res.result.totalElements;
             
              obj.listLength4 += 20;  
              var objDiv = document.getElementById("COMPLETION0");  
              let top = document.getElementById("COMPLETION"); 
              top.scrollTop = (objDiv.scrollHeight*(obj.listLength4-20)) +objDiv.scrollHeight; 
            }
          })
        .catch(function (err) {
          console.log(err);
        });
      } 
    },
    checkReadfilter(){
      this.getKanbanAllBoardList();
      // this.setFilter();
      // if(this.checkFilterRead){
      //   this.listFilter1 = this.list1.filter(function(data){
      //       return data.readCount == null || data.readCount == 0
      //   });
      //   this.listFilter2 = this.list2.filter(function(data){
      //       return data.readCount == null || data.readCount == 0
      //   });
      //   this.listFilter3 = this.list3.filter(function(data){
      //       return data.readCount == null || data.readCount == 0
      //   });
      //   this.listFilter4 = this.list4.filter(function(data){
      //       return data.readCount == null || data.readCount == 0
      //   });
      // }else{
      //   this.listFilter1 = this.list1;
      //   this.listFilter2 = this.list2;
      //   this.listFilter3 = this.list3;
      //   this.listFilter4 = this.list4; 
      // }
    },
    getKanbanAllBoardList() {
      let obj = this;
      obj.page1 = 0;
      obj.page2 = 0;
      obj.page3 = 0;
      obj.page4 = 0;
      obj.listLength1 = 20;
      obj.listLength2 = 20;
      obj.listLength3 = 20;
      obj.listLength4 = 20;

      let list = [];
      list.push('GOOD'); 
      list.push('SO'); 
      list.push('DELAY'); 
      list.push('EXCEEDED');
      let axiosArr = []; 
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let status = list[inx];    
          let url = "/api/copaper/paper/getPaperStatusPaperList"
          let data = {
            paperStatus: status,
            groupId: obj.groupId,
            limitRow: "20",
            page: 0,
            isPaperBookmarkChecked: obj.checkFilterBookmark,
            isPaperReadChecked: obj.checkFilterRead,
            categoryMidList: obj.categoryMidList,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }
      }
      //프로그레스바 시작 
      this.showLoadingbar();
      if(axiosArr.length > 0) {
        axios.all(axiosArr).then(axios.spread((...responses) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if(responses.length > 0) { 
            this.list1 = responses[0].data.result.content;
            this.listFilter1 = responses[0].data.result.content;
            this.listTotalElements1 = responses[0].data.result.totalElements;
            this.list2 = responses[1].data.result.content;
            this.listFilter2 = responses[1].data.result.content;
            this.listTotalElements2 = responses[1].data.result.totalElements;
            this.list3 = responses[2].data.result.content;
            this.listFilter3 = responses[2].data.result.content;
            this.listTotalElements3 = responses[2].data.result.totalElements;
            this.list4 = responses[3].data.result.content;
            this.listFilter4 = responses[3].data.result.content;
            this.listTotalElements4 = responses[3].data.result.totalElements;
            
            let sessionState = JSON.parse(window.sessionStorage.getItem("private")) || []; 
            if(sessionState.length != 0){
              let lastState = sessionState.pop();
              lastState.isPaperBookmarkChecked = obj.checkFilterBookmark;
              lastState.isPaperReadChecked = obj.checkFilterRead; 
              lastState.statusList = obj.statusList;
              lastState.categoryMidList = obj.categoryMidList;
              lastState.gradeCodeList = obj.gradeCodeList;
              lastState.statusCheckYn = obj.statusCheckYn;
              lastState.categoryCheckYn = obj.categoryCheckYn;
              lastState.gradeCheckYn = obj.gradeCheckYn;
              sessionState.push(lastState);
              window.sessionStorage.setItem("private", JSON.stringify(sessionState));
            }

          }
        })).catch(errors => { 
          //프로그레스바 종료
          this.hideLoadingbar();
        });
      }
    },
    updateCommonFilterB(filterData) {
      this.categoryMidList = filterData.filterCategoryMidList;
      this.gradeCodeList = filterData.filterGradeList;
      this.statusList = filterData.filterStatusList;
      this.categoryCheckYn = filterData.categoryCheckYn;
      this.gradeCheckYn = filterData.gradeCheckYn;
      this.statusCheckYn = filterData.statusCheckYn;
      this.getKanbanAllBoardList();
    },
    checkHours(lastUpdated) {
      let now = this.$moment()
      let before24hours = this.$moment().subtract(1,'days')
      let lastUpdatedTime = this.$moment(lastUpdated)
      
      if(lastUpdatedTime.isBetween(before24hours, now)) {
        // 24시간 이내
        return true;
      }else{
        // 24시간 이후
        return false;
      }
    },
    replaceAll(str, input, output) {
      return str.split(input).join(output);
    },
    /* IE 말줄임 */
    multiElipsis(ellipsisLine, paperId) {
      this.$nextTick(function(){
        let selecter = "multi-ellipsis " + paperId + "_kanban";
        var omle = document.getElementsByClassName(selecter);
        // console.log(paperId, omle);
        for(let item of omle){
          if (item.scrollHeight < 55) {
              item.classList.remove("multi-ellipsis");
          } 
        } 
      });
    },
  }/* methods end */
};
</script>
<style scoped>
.ell-multiline2 {
  word-break: break-all;
  cursor: pointer;
}

/* .nodata{
  position: relative;
  top: -191px;
}

.kanban-cnt_ty1 [class*="kanban-col"] + [class*="kanban-col"] {
  max-height: 631px;
} */

.nodata {
  position: relative;
  margin-top: -191px; 
} 
.kanban-cnt_ty1 [class*="kanban-col"] {
  max-height: 631px;
}
.kanban-list-wrap {
  max-height: 442px;
}


.folder_name {
  display: block;
}
.tooltip-b {
  display:none; z-index: 10; word-break: break-all; position: absolute; width: calc(80%);
}
.ell-singleline,
.tooltip-b {
  /* white-space: normal; */
}
.tooltip-b.tl.linkedTooltip {
  left: calc(10%);
}
.tooltip-b.tl.linkedTooltip::before {
  left: calc(90%);
}
.tooltip-b.tl.paperTitle {
  /* margin-top: -18px; */
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  line-height: 1.44;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.44em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/tab/board/BoardKanban.vue